export default __webpack_public_path__ + "static/media/wealth5.f620675a.png";